// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary_container__3qfQd","image":"ErrorBoundary_image__1gNT6"};